import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

export const tableSlotRecipe = defineSlotRecipe({
  className: 'table',
  slots: tableAnatomy.keys(),
  base: {
    header: {
      border: '1px solid {colors.white}',
      '& > tr > th': {
        borderRight: '1px solid {colors.white}',
      },
      '& > tr > th:last-child': {
        borderRight: 0,
      },
    },
    body: {
      bgColor: 'white',
    },
  },
  variants: {
    variant: {
      simple: {
        header: {
          bgColor: 'blackAlpha.200',
        },
        columnHeader: {
          px: 2,
          py: 2.5,
          lineHeight: 'unset',
        },
        row: {
          '& > th:first-of-type': {
            borderTopLeftRadius: '7px',
          },
          '& > th:last-of-type': {
            borderTopRightRadius: '7px',
          },
        },
      },
    },
    size: {
      md: {
        columnHeader: {
          fontSize: 'lg',
        },
      },
    },
  },
});
